import { Pipe, PipeTransform } from '@angular/core';

// Interfaces
import { Entidad, EntidadJuzgado } from '@sistema/pages/entidad-page/interfaces';

@Pipe({ name: 'EntidadNombre' })
export class EntidadNombrePipe implements PipeTransform {
  transform(id: number | null, entidades: Entidad[]): string {
    if (!id || !entidades) return '';
    const entidad = entidades.find((m) => m.id === id);
    return entidad?.nombre || id.toString();
  }
}

@Pipe({ name: 'EntidadNombreJuzgado' })
export class EntidadNombreJuzgadoPipe implements PipeTransform {
  transform(id: number | null, entidades: EntidadJuzgado[]): string {
    if (!id || !entidades) return '';
    const entidad = entidades.find((m) => m.entidadId === id);
    return entidad?.nombre || id.toString();
  }
}
